module.exports = __webpack_public_path__ + "img/services.cf3e50b3.jpeg";